/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The UserDto model module.
 * @module model/UserDto
 * @version v0
 */
class UserDto {
    /**
     * Constructs a new <code>UserDto</code>.
     * @alias module:model/UserDto
     * @param roleId {Number} 
     * @param username {String} 
     * @param email {String} 
     * @param name {String} 
     * @param surname {String} 
     * @param validated {Boolean} 
     * @param password {String} 
     */
    constructor(roleId, username, email, name, surname, validated, password) { 
        
        UserDto.initialize(this, roleId, username, email, name, surname, validated, password);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, roleId, username, email, name, surname, validated, password) { 
        obj['role_id'] = roleId;
        obj['username'] = username;
        obj['email'] = email;
        obj['name'] = name;
        obj['surname'] = surname;
        obj['validated'] = validated;
        obj['password'] = password;
    }

    /**
     * Constructs a <code>UserDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UserDto} obj Optional instance to populate.
     * @return {module:model/UserDto} The populated <code>UserDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UserDto();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('role_id')) {
                obj['role_id'] = ApiClient.convertToType(data['role_id'], 'Number');
            }
            if (data.hasOwnProperty('username')) {
                obj['username'] = ApiClient.convertToType(data['username'], 'String');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('surname')) {
                obj['surname'] = ApiClient.convertToType(data['surname'], 'String');
            }
            if (data.hasOwnProperty('validated')) {
                obj['validated'] = ApiClient.convertToType(data['validated'], 'Boolean');
            }
            if (data.hasOwnProperty('password')) {
                obj['password'] = ApiClient.convertToType(data['password'], 'String');
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'Date');
            }
            if (data.hasOwnProperty('updated_at')) {
                obj['updated_at'] = ApiClient.convertToType(data['updated_at'], 'Date');
            }
            if (data.hasOwnProperty('created_by')) {
                obj['created_by'] = ApiClient.convertToType(data['created_by'], 'String');
            }
            if (data.hasOwnProperty('updated_by')) {
                obj['updated_by'] = ApiClient.convertToType(data['updated_by'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>UserDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>UserDto</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of UserDto.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['username'] && !(typeof data['username'] === 'string' || data['username'] instanceof String)) {
            throw new Error("Expected the field `username` to be a primitive type in the JSON string but got " + data['username']);
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // ensure the json data is a string
        if (data['surname'] && !(typeof data['surname'] === 'string' || data['surname'] instanceof String)) {
            throw new Error("Expected the field `surname` to be a primitive type in the JSON string but got " + data['surname']);
        }
        // ensure the json data is a string
        if (data['password'] && !(typeof data['password'] === 'string' || data['password'] instanceof String)) {
            throw new Error("Expected the field `password` to be a primitive type in the JSON string but got " + data['password']);
        }
        // ensure the json data is a string
        if (data['created_by'] && !(typeof data['created_by'] === 'string' || data['created_by'] instanceof String)) {
            throw new Error("Expected the field `created_by` to be a primitive type in the JSON string but got " + data['created_by']);
        }
        // ensure the json data is a string
        if (data['updated_by'] && !(typeof data['updated_by'] === 'string' || data['updated_by'] instanceof String)) {
            throw new Error("Expected the field `updated_by` to be a primitive type in the JSON string but got " + data['updated_by']);
        }

        return true;
    }


}

UserDto.RequiredProperties = ["role_id", "username", "email", "name", "surname", "validated", "password"];

/**
 * @member {Number} id
 */
UserDto.prototype['id'] = undefined;

/**
 * @member {Number} role_id
 */
UserDto.prototype['role_id'] = undefined;

/**
 * @member {String} username
 */
UserDto.prototype['username'] = undefined;

/**
 * @member {String} email
 */
UserDto.prototype['email'] = undefined;

/**
 * @member {String} name
 */
UserDto.prototype['name'] = undefined;

/**
 * @member {String} surname
 */
UserDto.prototype['surname'] = undefined;

/**
 * @member {Boolean} validated
 */
UserDto.prototype['validated'] = undefined;

/**
 * @member {String} password
 */
UserDto.prototype['password'] = undefined;

/**
 * @member {Date} created_at
 */
UserDto.prototype['created_at'] = undefined;

/**
 * @member {Date} updated_at
 */
UserDto.prototype['updated_at'] = undefined;

/**
 * @member {String} created_by
 */
UserDto.prototype['created_by'] = undefined;

/**
 * @member {String} updated_by
 */
UserDto.prototype['updated_by'] = undefined;






export default UserDto;

